import styled, { css } from 'styled-components';
import { PillsTab, TabProps } from '@gr-monorepo/common/ui/SwitchTabs/SwitchTabsStyled';

export const BluePillsTab = styled(PillsTab)`
  box-shadow: 0px 4px 8px rgba(57, 78, 127, 0.2);
  min-width: 60px;
  padding: 12px 16px;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.64px;

  ${(props) =>
    props.activated &&
    css`
      box-shadow: none;
      background-color: #c6eafd;
      &:after {
        background: #c6eafd;
      }
    `}
`;

export const PurplePillsTab = styled(BluePillsTab)`
  ${(props) =>
    props.activated &&
    css`
      background-color: #ebe0ff;
      &:after {
        background: #ebe0ff;
      }
    `}
`;

export const BlueLinksTab = styled.a<TabProps>`
  margin-right: 24px;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  color: #12b7e7;
  cursor: pointer;

  text-transform: uppercase;
  text-decoration: underline;

  &:visited,
  &:focus,
  &:active,
  &:hover {
    color: #12b7e7;
    text-decoration: underline;
  }

  ${(props) =>
    props.activated &&
    css`
      text-decoration: none;
      color: rgba(9, 21, 38, 0.85);
      &:visited,
      &:focus,
      &:active,
      &:hover {
        color: rgba(9, 21, 38, 0.85);
        text-decoration: none;
      }
    `};
`;

export const BlueLinksTabSmall = styled(BlueLinksTab)`
  font-size: 16px;
`;
